import styled from "styled-components";


export const StyledSearchableMultiInput = styled.div`
  /* Target all possible input-related elements */
  .mantine-PillsInput-input {
    &:focus-within {
      box-shadow: inset 0 0 0 1px var(--clr-primary-400) !important;
      border-color: transparent !important;
    }
  }
  
  input[type="text"],
  .mantine-PillsInput-field,
  [data-mantine-component="PillsInput.Field"] {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;

    &:focus,
    &:focus-visible,
    &:focus-within,
    &:hover,
    &:active {
      
      border: none !important;
      outline: none !important;
      box-shadow: none !important;
    }
  }
`;
